import React from "react";

import { Outlet, Navigate, useSearchParams } from "react-router-dom";
import { useAppSelector } from "@/hooks/hook";

const PrivateRoutes = () => {
  const [currentQueryParameters, setSearchParams] = useSearchParams();
  const id = currentQueryParameters.get('id')
  if(id){
    localStorage.setItem('eventId',id)
  }
  const { accessToken } = useAppSelector((store: any) => store.user);
  return accessToken === null || accessToken === undefined ? <Navigate to="/login" /> : <Outlet />;
};

export default PrivateRoutes;
